import React from 'react';
import { Tooltip, TooltipProps } from '../tooltip';
import { Box } from '../box';

export interface FormFieldTooltipProps extends Omit<TooltipProps, 'title' | 'onClose'> {
  onClose: NonNullable<TooltipProps['onClose']>;
  message?: React.ReactNode;
}

export const FormFieldTooltip: React.FC<FormFieldTooltipProps> = ({ message, ...props }) => {
  return <Tooltip arrow disableHoverListener placement="bottom-start" title={<Box sx={{ p: 1 }}>{message}</Box>} {...props} />;
};
